import DashboardDefaultChartEmptyState from "./DashboardDefaultChartEmptyState";

export default DashboardDefaultChartEmptyState;
